import _ from 'lodash';

function DeviceCtrl($rootScope, $scope, $timeout, toastr, uiCalendarConfig, AuthService, PlanService, UserService) {
  'ngInject';


  console.log('DeviceCtrl.....')

  // ViewModel
  const vm = this;

  $rootScope.$emit('base:sidebarEvent', 'open');
  


}

export default {
  name: 'DeviceCtrl',
  fn: DeviceCtrl
};
